import React from 'react';
import { IconButton, IconButtonProps } from '../iconButton';
import Close from '../icons/Close';

export interface DialogCloseButtonProps extends Omit<IconButtonProps, 'aria-label'> {
  'aria-label'?: IconButtonProps['aria-label'];
}

export const DialogCloseButton = React.forwardRef(
  (props: DialogCloseButtonProps, ref: React.RefObject<HTMLButtonElement>) => {
    const { sx, ...rest } = props;
    return (
      <IconButton
        size="small"
        aria-label="Close dialog"
        {...rest}
        sx={{
          float: 'right',
          ...sx,
        }}
        ref={ref}
      >
        <Close />
      </IconButton>
    );
  },
);
